// https://www.youtube.com/watch?v=6-CsXSfSVNY&list=PLIOKyGYW8AAtvI5DnaCXb1dmcofnh4uqC&index=33&t=5s

import { useEffect, useState, useCallback } from "react";
import "./App.css";
import { createWorker } from "tesseract.js";

function App() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [textResult, setTextResult] = useState("");

  const worker = createWorker();

  // const convertImageToText = async () => {
  //   await worker.load();
  //   await worker.loadLanguage("eng");
  //   await worker.initialize("eng");
  //   const { data } = await worker.recognize(selectedImage);
  //   console.log(data);
  //   setTextResult(data.text);
  // };

  const convertImageToText = useCallback(async () => {
    if (!selectedImage) return;
    await worker.load();
    await worker.loadLanguage("eng");
    await worker.initialize("eng");
    const { data } = await worker.recognize(selectedImage);
    setTextResult(data.text);
  }, [worker, selectedImage]);

  useEffect(() => {
    convertImageToText();
  }, [selectedImage, convertImageToText]);

  const handleChangeImage = (e) => {
    if (e.target.files[0]) {
      setSelectedImage(e.target.files[0]);
    } else {
      setSelectedImage(null);
      setTextResult("");
    }
  };
  return (
    <div className="App">
      <h1>image to text</h1>
      <div className="input-wrapper">
        <label htmlFor="upload">upload image</label>
        <input
          type="file"
          id="upload"
          accept="image/*"
          onChange={handleChangeImage}
        />
      </div>
      <div className="result">
        {selectedImage && (
          <div className="box-image">
            <img src={URL.createObjectURL(selectedImage)} alt="thumb" />
          </div>
        )}
        {textResult && (
          <div className="box-p">
            <p>{textResult}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
